export default "__VITE_ASSET__DOTVQK9U__"